module.exports = __webpack_public_path__ + "/login_ui/img/ss-2a4a236afe92a97934c8948b0f1b924e.svg";